import { email as validEmail } from '../../utils/validations';
import { messages } from '../../language';
import {
  strictValidObjectWithKeys,
  strictValidString,
  validObjectWithParameterKeys,
} from '../../utils/commonUtils';

const validate = (values) => {
  const errors = { user: {} };
  const { job_functions, primary_resume } = values; // industries
  const { first_name, last_name, phone, email, source } = values.user || {};

  if (!first_name) {
    errors.user.first_name = messages.VALIDATIONS.INVALID_FIRST_NAME;
  }
  if (!last_name) {
    errors.user.last_name = messages.VALIDATIONS.INVALID_LAST_NAME;
  }
  if (!phone || phone.length < 10) {
    errors.user.phone = messages.VALIDATIONS.INVALID_PHONE_NUMBER;
  }
  if (!email) {
    errors.user.email = messages.VALIDATIONS.INVALID_EMAIL_ADDRESS;
  }
  const isEmailNotValid = validEmail(email);
  if (isEmailNotValid) {
    errors.user.email = isEmailNotValid;
  }
  if (
    !(
      validObjectWithParameterKeys(values.address, ['city', 'state']) &&
      strictValidString(values.address.city)
    )
  ) {
    errors.address = messages.VALIDATIONS.REQUIRED;
  }
  if (job_functions && job_functions.length === 0) {
    errors.job_functions =
      messages.VALIDATIONS.AT_LEAST_ONE_JOB_INTERESTS_IS_REQUIRED;
  }

  if (!source) {
    errors.user.source = messages.VALIDATIONS.INVALID_SOURCE;
  }

  // remove primary resume required validation
  // if (!strictValidObjectWithKeys(primary_resume)) {
  //   errors.primary_resume = messages.VALIDATIONS.REQUIRED;
  // }

  return errors;
};

export default validate;
